import { Box, Skeleton } from '@mui/material';

const WorkQueueKPIsSkeleton = () => (
	<Box
		role='status'
		aria-label='Loading Work Queue KPIs'
		sx={{
			display: 'grid',
			gridTemplateColumns: {
				xs: 'repeat(2, minmax(0, 1fr))',
				md: 'repeat(4, minmax(0, 1fr))',
			},
			gap: '10px',
		}}
	>
		{Array.from({ length: 4 }, (_, index) => (
			<Box
				key={index}
				sx={{
					p: '14px',
					border: '0.5px solid',
					borderColor: 'border.light',
					borderRadius: '8px',
					backgroundColor: 'background.paper',
				}}
			>
				<Skeleton variant='text' width='65%' height={18} />
				<Skeleton variant='text' width='40%' height={36} />
			</Box>
		))}
	</Box>
);

export default WorkQueueKPIsSkeleton;
